@if (parentForm) {
<div [formGroup]="parentForm" [ngClass]="innerClass">
  <mat-label *ngIf="label" [ngClass]="{'required': inError}"> {{ label }}
    <span class="required" *ngIf="required">*</span>
  </mat-label>
  <mat-form-field appearance="outline" color="primary">
    <!--      <mat-label>{{ placeholder }}</mat-label>-->
    <input matInput [matDatepicker]="picker" [ngClass]="{'border-error': inError}" [min]="minDate" [max]="maxDate"
      [formControlName]="controlName" [placeholder]="placeholder" [readonly]="readonly"
      (click)="!readonly ? null : picker.open()">
    <mat-hint *ngIf="hintText">{{hintText}}</mat-hint>
    <button *ngIf="clearable && hasValue" matIconSuffix type="button" class="date-clear-btn"
            (click)="clear($event)" aria-label="Effacer la date">×</button>
    <mat-datepicker-toggle matIconSuffix [for]="picker">
      <svg-icon matDatepickerToggleIcon src="assets/icons/calender-check-primary.svg"></svg-icon>
      <!--    <mat-icon matDatepickerToggleIcon>arrow_drop_down</mat-icon>-->
    </mat-datepicker-toggle>
    <mat-datepicker #picker></mat-datepicker>
  </mat-form-field>
  <!--calender-check-primary.svg-->

</div>

} @else {
<div [ngClass]="innerClass">
  <mat-label>{{ label }}
    <span class="required">*</span>
  </mat-label>
  <mat-form-field appearance="outline">
    <mat-label>{{ placeholder }}</mat-label>
    <input matInput [matDatepicker]="picker" [disabled]="disabled">
    <mat-hint *ngIf="hintText">{{hintText}}</mat-hint>
    <mat-datepicker-toggle matIconSuffix [for]="picker">
      <svg-icon matDatepickerToggleIcon src="assets/icons/calender-check-primary.svg"></svg-icon>
      <!--    <mat-icon matDatepickerToggleIcon>arrow_drop_down</mat-icon>-->
    </mat-datepicker-toggle>
    <mat-datepicker #picker></mat-datepicker>
  </mat-form-field>
  <!--calender-check-primary.svg-->

</div>

}
<div class="invalid-feedback" *ngIf="errorMessage">{{errorMessage}}</div>